export default __webpack_public_path__ + "static/Swiss721BT-Roman-9c0c9c8b4bd47ea6b8953dfe168c4c08.ttf";